import { ClassProvider } from "@angular/core";
import { Client } from "./client";

export const provideNSwagClient = (): ClassProvider => ({
  provide: Client,
  useClass: Client,
  multi: false,
});
